export { useDeviceInfo } from './useDeviceInfo';
